import { Edit, Trash2, Building, CreditCard, CheckCircle, XCircle } from 'lucide-react'
import { LoadingSpinner } from '../common'

function BankDetailList({ 
  bankDetails, 
  isLoading, 
  onEdit, 
  onDelete,
  onToggleStatus,
  userRole
}) {
  if (isLoading) {
    return (
      <div className="card">
        <div className="card-content p-0">
          <LoadingSpinner size="lg" className="h-64" />
        </div>
      </div>
    )
  }

  if (!bankDetails || bankDetails.length === 0) {
    return (
      <div className="card">
        <div className="card-content">
          <div className="text-center py-12">
            <Building className="mx-auto h-12 w-12 text-secondary-400" />
            <h3 className="mt-2 text-sm font-medium text-secondary-900">No bank details found</h3>
            <p className="mt-1 text-sm text-secondary-500">Get started by creating a new bank detail.</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="card">
      <div className="card-content p-0">
        <div className="overflow-x-auto">
          <table className="table">
            <thead className="table-header">
              <tr className="table-row">
                <th className="table-head">Bank</th>
                <th className="table-head">Account Number</th>
                <th className="table-head">IFSC Code</th>
                <th className="table-head">Branch Name</th>
                <th className="table-head">Company</th>
                <th className="table-head">Status</th>
                <th className="table-head">Actions</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {bankDetails.map((bankDetail) => (
                <tr key={bankDetail.id} className="table-row">
                  <td className="table-cell">
                    <div className="flex items-center">
                      <div className="h-8 w-8 bg-primary-100 rounded-full flex items-center justify-center">
                        <Building className="h-4 w-4 text-primary-600" />
                      </div>
                      <div className="ml-3">
                        <div className="text-base font-medium text-secondary-900">
                          {bankDetail.bankName}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="flex items-center">
                      <CreditCard className="h-4 w-4 text-secondary-400 mr-2" />
                      <div className="text-base text-secondary-900">
                        {bankDetail.accountNumber}
                      </div>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="text-base text-secondary-900 font-mono">
                      {bankDetail.ifscCode}
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="text-base text-secondary-900">
                      {bankDetail.branchName}
                    </div>
                  </td>
                  <td className="table-cell">
                    {bankDetail.company ? (
                      <div className="text-base text-secondary-900">
                        {bankDetail.company.name}
                      </div>
                    ) : (
                      <span className="text-sm text-secondary-500">N/A</span>
                    )}
                  </td>
                  <td className="table-cell">
                    <div className="flex items-center">
                      {bankDetail.isActive ? (
                        <CheckCircle className="h-4 w-4 text-green-600 mr-1" />
                      ) : (
                        <XCircle className="h-4 w-4 text-red-600 mr-1" />
                      )}
                      <span className={`badge ${bankDetail.isActive ? 'badge-success' : 'badge-danger'}`}>
                        {bankDetail.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() => onEdit(bankDetail)}
                        className="text-primary-600 hover:text-primary-900"
                        title="Edit"
                      >
                        <Edit className="h-4 w-4" />
                      </button>
                      {userRole === 1 && (
                        <>
                          {onToggleStatus && (
                            <button
                              onClick={() => onToggleStatus(bankDetail)}
                              className={`text-sm ${bankDetail.isActive ? 'text-yellow-600 hover:text-yellow-900' : 'text-green-600 hover:text-green-900'}`}
                              title={bankDetail.isActive ? 'Deactivate' : 'Activate'}
                            >
                              {bankDetail.isActive ? 'Deactivate' : 'Activate'}
                            </button>
                          )}
                          <button
                            onClick={() => onDelete(bankDetail)}
                            className="text-danger-600 hover:text-danger-900"
                            title="Delete"
                          >
                            <Trash2 className="h-4 w-4" />
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default BankDetailList

